import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';

import { UIDataModel, UIComponentState } from '../../../../toolkit/uicomponent';
import * as React from 'react';

import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { PaginationVerticalListComponent } from '../../../../toolkit/verticallist/paginationverticallist/paginationverticallistcomponent';
import { ArtistTabSearchListCSSStyle } from './artistsearchlistcss';
import { ArtistTabSearchListComponentProps, ArtistTabSearchlistComponentHandler } from './artistsearchlistcomponent';

export class ArtistTabSearchListViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private paginationListRef: PaginationVerticalListComponent<ToneDto> | null;

    draw(props: ArtistTabSearchListComponentProps, state: UIComponentState, cssStyle: ArtistTabSearchListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
              <PaginationVerticalListComponent ref={(item: any) => {this.paginationListRef = item;}} onLoadMore={(this.getUIComponentHandler() as ArtistTabSearchlistComponentHandler).onLoadMore} listViewModel={props.listViewModel} context={props.context}/>
        );
    }

    updatePaginationCount()
    {
        this.paginationListRef !== null && this.paginationListRef.updatePaginationCount();
    }

    resetPaginationCount()
    {
        this.paginationListRef !== null && this.paginationListRef.resetPaginationCount();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/artist/artistsearchlistview.tsx